import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Slider from '@mui/material/Slider';
import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeUp from '@mui/icons-material/VolumeUp';

import HexagonOutlinedIcon from '@mui/icons-material/HexagonOutlined';
import HexagonTwoToneIcon from '@mui/icons-material/HexagonTwoTone';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import Select, { SelectChangeEvent } from '@mui/material/Select';

import {
    select_userMessage, setUserMessage, setMap
} from 'src/reducers/basicReducer';
import { useDispatch, useSelector } from 'react-redux'

import { useAppSelector, useAppDispatch } from 'src/hooks';

import { debounce } from "lodash"



export default function Alpha_slider() {
    const [value, setValue] = React.useState<number>(0.5);
    // This is just to allow slider dragging/movement. It updates the value shown by the slider only,
    // so it's very fast.
    const handleChange = (event: Event, newValue: number | number[]) => {
        setValue(newValue as number);
    };

    const dispatch = useDispatch()
    // This actually changes opacity, which re-renders map, etc. This is much slower, so we just call it "onChangeCommitted"
    const change_opacity2 = (event: Event | React.SyntheticEvent<Element, Event>, value: number | number[]) => {
        console.log("Setting opacity to: " + value)
        dispatch(setMap({ name: 'opacity', value: value }));
    };

    // For a simple slider, it looks like we don't need to wrap in FormControl:
    // https://stackoverflow.com/questions/58188214/what-is-formcontrol-used-for-why-is-it-used-how-should-it-be-used
    return (
        <Box sx={{ mt: 1.5, mb: 3.5, justifyContent: 'center' }}>
            <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                <HexagonOutlinedIcon />
                {/* https://stackoverflow.com/questions/62522994/how-do-i-lower-the-rate-of-http-requests-triggered-due-to-onchange-for-material
                Update: I don't think debouncing is the right solution. The problem is that the slider and opacity value are directly linked, so
                debouncing just makes the slider "sticky." That is, the slider can't move until after the debouncing delay (?) 
                Alternative(s): https://stackoverflow.com/questions/54763083/react-native-slider-onvaluechange-calling-setstate-makes-slider-lag */}
                <Slider
                    aria-label="Opacity"
                    min={0.2}
                    max={0.8}
                    step={0.01}
                    value={value}
                    onChange={handleChange}
                    onChangeCommitted={change_opacity2}
                />
                <HexagonTwoToneIcon />
            </Stack>
        </Box>
    );
}
